export default __webpack_public_path__ + "static/media/palhaco-balls.d5c57049.png";